import { render, staticRenderFns } from "./lookBook.vue?vue&type=template&id=bdd753fe&scoped=true"
import script from "./lookBook.vue?vue&type=script&lang=js"
export * from "./lookBook.vue?vue&type=script&lang=js"
import style0 from "./lookBook.vue?vue&type=style&index=0&id=bdd753fe&prod&lang=less&scoped=true"
import style1 from "./lookBook.vue?vue&type=style&index=1&id=bdd753fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd753fe",
  null
  
)

export default component.exports